import axios from './interceptor'
import { baseUrl } from './config'
import * as moment from 'moment'

export default {
  async redeemPromoCode (param) {
    return axios.get(`${baseUrl}/c/promocode/validate`, {
      params: {
        merchantId: param.merchantId,
        code: param.promoCode,
      },
    }).then(r => {
      const data = r.data
      if (
        !data ||
        (data.quota && (data.usedTime >= data.quota)) ||
        !(moment().isBetween(moment(data.validFrom), moment(data.validUntil)))
      ) {
        return { success: false, message: 'takeaway.order.promo.code.invalid' }
      }

      return { success: true, data }
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/api/promo_code.js